"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SmartHome_1 = require("./SmartHome");
exports.SystemAlertEventType = SmartHome_1.SmartHomeType;
exports.SystemAlertCreateEventType = 'SystemAlertCreate';
exports.SystemAlertDismissEventType = 'SystemAlertDismiss';
